import script from "./label_button.vue?vue&type=script&setup=true&lang=js"
export * from "./label_button.vue?vue&type=script&setup=true&lang=js"

import "./label_button.vue?vue&type=style&index=0&id=448ab402&scoped=true&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-448ab402"]])

export default __exports__